// extracted by mini-css-extract-plugin
module.exports = {"overlay":"src-reactapp-shared-Popover---overlay","overlay-backdrop":"src-reactapp-shared-Popover---overlay-backdrop"};